<script>
import ElCollapse from 'element-ui/packages/collapse/src/collapse'

export default {
  name: 'ElCollapse',
  extends: ElCollapse,
  render (h) {
    const vnode = ElCollapse.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-collapse']
    return vnode
  }
}
</script>
